import { render, staticRenderFns } from "./FormularioPessoaOperacao.vue?vue&type=template&id=b9dd20c2&scoped=true&lang=pug"
import script from "./FormularioPessoaOperacao.vue?vue&type=script&lang=js"
export * from "./FormularioPessoaOperacao.vue?vue&type=script&lang=js"
import style0 from "./FormularioPessoaOperacao.vue?vue&type=style&index=0&id=b9dd20c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9dd20c2",
  null
  
)

export default component.exports